import React, { Fragment } from "react";
import { graphql } from "gatsby";
import Block from "../../Block";
import Blocks from "templates/Blog/Gutenberg/Blocks";

class CoreGroup extends Block {
  render() {
    const { context, block, factory } = this.props;
    const innerBlocks = block.innerBlocks;

    return (
      <div className="core-group">
        {block.innerBlocks &&
          block.innerBlocks.map((block, index) => (
            <div key={`blog_columns_${block.order}_inner_${index}`}>
              {factory.create({ context, block })}
            </div>
          ))}
      </div>
    );
  }
}

class CoreGroupFactory {
  constructor(blockBuildingFactory) {
    this.blockBuildingFactory = blockBuildingFactory;
  }

  get type() {
    return "core/group";
  }

  create(props) {
    return <CoreGroup factory={this.blockBuildingFactory} {...props} />;
  }
}

export default CoreGroupFactory;
